import { NotificationUnreadCountsView } from './view/NotificationUnreadCountsView';

const EVENT = 'bbx_notification_counts_changed';

/**
 * Lets whoever changes the read state tell the header badge to refresh at once, instead of
 * leaving it stale until the next poll. The legacy back office got this for free: every
 * navigation was a full page load, so the badge was recomputed each time.
 *
 * The fresh counts travel with the event, so the badge updates without a second round trip.
 */
export const notificationCountsStore = {
    notifyChanged: (counts: NotificationUnreadCountsView): void => {
        window.dispatchEvent(new CustomEvent(EVENT, { detail: counts }));
    },

    subscribe: (cb: (counts: NotificationUnreadCountsView) => void): (() => void) => {
        const listener = (event: Event) => cb((event as CustomEvent<NotificationUnreadCountsView>).detail);
        window.addEventListener(EVENT, listener);
        return () => window.removeEventListener(EVENT, listener);
    },
};
